<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      EditDocumentRequirementButtonModal(:item="item")
      ActionButton(:action="remove", :confirm="true") Delete


</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from "../ActionButton";
import CreateDocumentTypeButtonModal from "./CreateDocumentTypeButtonModal.vue";
import CreateDocumentRequirementButtonModal from "./CreateDocumentRequirementButtonModal.vue";
import EditDocumentRequirementButtonModal from "./EditDocumentRequirementButtonModal.vue";

export default {
  name: 'DocumentRequirementButtons',
  components: {
    EditDocumentRequirementButtonModal,
    CreateDocumentRequirementButtonModal, CreateDocumentTypeButtonModal, ActionButton, ModalReveal},
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    remove: function () {
      return KeplerBackofficeSdk.documentRequirements.select(this.item).remove(() => {
        MaggieHelper.notification('delete-esit', 'Document type removed')
        this.$emit('itemUpdated')
      })
    },
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentRequirementButtons.vue?32e234d5